import { Map, Set } from "immutable";
import * as GQL from "src/types/graphql";
import { CompositeStatus, Mixed } from "./VerificationInput";

export type BulkVerificationSummary = {
  verification: {
    id: uuid;
    label: string;
  };
  applicableAppIds: Set<uuid>;
  applicableVerificationResults: Map<uuid, GQL.verification_status_enum>;
  compositeStatus: CompositeStatus;
};

export function processVerificationSummary(
  verification: GQL.GetApplicableVerificationsSummaries_form_verification,
  formIds: uuid[]
): BulkVerificationSummary {
  const applicableAppIds = Set(
    verification.questions.some((q) => q.form_template_section_id)
      ? formIds
      : verification.questions.flatMap((q) =>
          q.ancestor_questions.flatMap((aq) =>
            aq.form_question_option.form_answer_options.map(
              (aao) => aao.form_answer.form_id as string
            )
          )
        )
  );
  const applicableVerificationResults = Map(
    verification.form_verification_results
      .filter((avr) => applicableAppIds.contains(avr.form_id))
      .map((avr) => [avr.form_id, avr.verification_status])
  );
  let statuses = Set(applicableVerificationResults.valueSeq());
  if (applicableVerificationResults.size < applicableAppIds.size) {
    statuses = statuses.add(GQL.verification_status_enum.Pending);
  }
  const compositeStatus: CompositeStatus =
    statuses.size > 1
      ? Mixed
      : statuses.first() ?? GQL.verification_status_enum.Pending;
  return {
    verification,
    applicableAppIds,
    applicableVerificationResults,
    compositeStatus,
  };
}
